import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import UnsubscribePage from '@/pages/UnsubscribePage';

// The token is the credential; it is deliberately optional so a truncated or
// hand-typed link renders an explanation instead of a router validation error.
// `category` only steers the copy: the token decides what is turned off.
const searchSchema = z.object({
  token: z.string().optional(),
  category: z.enum(['reengagement']).optional(),
});

export const Route = createFileRoute('/unsubscribe')({
  component: UnsubscribeRoute,
  validateSearch: searchSchema,
});

function UnsubscribeRoute() {
  const { token, category } = Route.useSearch();
  return <UnsubscribePage token={token} category={category} />;
}
